export const queue = [];

export const pseudoDeadLetterQueue = [];
